var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBanner)?_c('text-banner',{attrs:{"title":"SWITCHING ORGANISATIONS","text":_vm.text,"icon":"fas fa-exchange-alt"},on:{"close":_vm.hideBanner}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }